import { ChartType } from '@dbl/core/chart';

import type {
  IAnalysisHorizontalBarChartResponseDto,
  IAnalysisHorizontalBarChartResultVo,
  TAnalysisHorizontalBarChartDataDto,
  TAnalysisHorizontalBarChartDataVo,
} from '../types';

import {
  isMissingWireArray,
  isNonEmptyWireArray,
  normalizeTableDataList,
  pickChartDisplayMeta,
} from './common';

/** HorizontalBar · `horizontal_bar_charts` wire 是否无有效数据。 */
function isHorizontalBarChartWireNoData(
  value: TAnalysisHorizontalBarChartDataDto | null | undefined,
): boolean {
  if (!isNonEmptyWireArray(value)) {
    return true;
  }

  const firstBlock = value[0];
  if (firstBlock == null || typeof firstBlock !== 'object') {
    return true;
  }

  return (
    isMissingWireArray(firstBlock.yAxis) ||
    isMissingWireArray(firstBlock.series)
  );
}

/** HorizontalBar · `horizontal_bar_charts` 透传；`null`/非数组兜底 `[]`。 */
function normalizeHorizontalBarChartData(
  value: TAnalysisHorizontalBarChartDataDto | null | undefined,
): TAnalysisHorizontalBarChartDataVo {
  if (!Array.isArray(value)) {
    return [];
  }

  return value.filter(
    item => item !== null && typeof item === 'object',
  ) as TAnalysisHorizontalBarChartDataVo;
}

export function transformHorizontalBarChartResponseDtoToVo(
  dto: IAnalysisHorizontalBarChartResponseDto,
): IAnalysisHorizontalBarChartResultVo {
  const {
    horizontal_bar_charts: horizontalBarDataWire,
    table_data: tableDataWire,
  } = dto;
  const isNoData = isHorizontalBarChartWireNoData(horizontalBarDataWire);

  return {
    ...pickChartDisplayMeta(dto),
    chartType: ChartType.HorizontalBarChart,
    isNoData,
    ...(isNoData
      ? {}
      : {
          horizontalBarData:
            normalizeHorizontalBarChartData(horizontalBarDataWire),
          tableData: normalizeTableDataList(tableDataWire),
        }),
  };
}
